import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import VisitInformation from '../VisitInformation';
import ContactInformation from '../ContactInformation';
import RestaurantInformation from '../RestaurantInformation';
import TextAreaField from '../TextAreaField';

import { row, column, clearfix } from '../../globals';

const ContactUsFormStyled = styled.div`
`;

const Row = styled.div`
  ${row(0)};
`;

const StyledField = styled.div`
    display: ${props => props.hide ? 'none' : 'inherit'};
    ${column(12, 'xs', 30)};
    ${clearfix()}
`;

const RestaurantInfo = styled.div`
    padding: 50px 30px;
    margin: 35px 0;
    background: white;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);
    border-radius: 3px;
    border: ${props => props.errors.locationId ? '1px solid rgb(205, 32, 40)' : 'none'};
`;

const FeedbackDetails = styled.div`
    background: white;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);
    border-radius: 3px;
    ${clearfix()};
`;

const VisitInformationStyled = styled.div`
    display: ${props => props.hide ? 'none' : 'inherit'};
`;

const diningOptions = (props) => {
    const optionsList = {
        DineIn: 'Dine In',
        CarryOut: 'Carry Out',
        PickUpWindow: 'Pick Up Window' };

    return Object.keys(optionsList)
        .map(option => props.getLocalizedText(option, optionsList[option]));
};

class ContactUsForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: props.date,
            time: props.time,
            diningType: props.diningType,
            comments: props.comments,
            firstName: props.firstName,
            lastName: props.lastName,
            contactPreference: props.contactPreference,
            emailId: props.emailId,
            phone: props.phone,
            preferredContactTime: props.preferredContactTime
        };
    }

    updateFeedback = (val) => {
        this.setState(val, this.props.handleFormUpdate(val));
    };

    validateComments = (e) => {
        if (!(e.target.value.trim())) {
            const errors = this.props.errors;
            errors.comments = true;
            this.setState({ comments: '' },
                this.props.handleFormUpdate({ errors, comments: '' }));
        }
    };

    render() {
        const restaurantInformation = this.props.showMap ?
            <RestaurantInfo {...this.props}>
                <RestaurantInformation locations={this.props.locations}
                                       locationSuggestions={this.props.locationSuggestions}
                                       onSearch={this.props.onSearch}
                                       clearLocationSuggestions={this.props.clearLocationSuggestions} // eslint-disable-line max-len
                                       onLocationSelection={this.props.onLocationSelection}
                                       getLocalizedText={this.props.getLocalizedText}
                                       errors={this.props.errors}
                                       locale={this.props.locale}
                />

            </RestaurantInfo>
            : '';

        return (
            <ContactUsFormStyled topMargin={this.props.showMap}>
                {restaurantInformation}
                <FeedbackDetails>
                    <VisitInformationStyled hide={!this.props.showMap}>
                        <VisitInformation diningOptions={diningOptions(this.props)}
                                          date={this.state.date}
                                          time={this.state.time}
                                          diningType={this.state.diningType}
                                          updateVisitInfo={ (val) => {
                                              this.updateFeedback(val);
                                          }}
                                          getLocalizedText={this.props.getLocalizedText}
                                          errors={this.props.errors}
                                          locale={this.props.locale} />
                    </VisitInformationStyled>
                    <Row>
                        <StyledField hide={!this.props.showMap}>
                            <TextAreaField id={'comments'} label={this.props.getLocalizedText('Comments', 'Comments')}
                                           value={this.state.comments}
                                           handleChange={(val) => {
                                               const errors = this.props.errors;
                                               errors.comments = false;
                                               // eslint-disable-next-line no-param-reassign
                                               val.errors = errors;
                                               this.updateFeedback(val);
                                           }}
                                           error={this.props.errors.comments ? this.props.getLocalizedText('Required', 'required') : ''}
                                           validate={this.validateComments}
                                           getLocalizedText={this.props.getLocalizedText}
                                           locale={this.props.locale} />
                        </StyledField>
                    </Row>
                    <ContactInformation showTitle={this.props.showMap}
                                        firstName={this.state.firstName}
                                        lastName={this.state.lastName}
                                        contactPreference={this.state.contactPreference}
                                        emailId={this.state.emailId}
                                        phone={this.state.phone}
                                        preferredContactTime={this.state.preferredContactTime}
                                        handleUpdate={(val) => {
                                            this.updateFeedback(val);
                                        }}
                                        getLocalizedText={this.props.getLocalizedText}
                                        errors={this.props.errors}
                                        locale={this.props.locale} />

                    <Row>
                        <StyledField hide={this.props.showMap}>
                            <TextAreaField id={'comments'} label={this.props.getLocalizedText('Comments', 'Comments')}
                                           value={this.state.comments}
                                           handleChange={(val) => {
                                               const errors = this.props.errors;
                                               errors.comments = false;
                                               // eslint-disable-next-line no-param-reassign
                                               val.errors = errors;
                                               this.updateFeedback(val);
                                           }}
                                           error={this.props.errors.comments ? this.props.getLocalizedText('Required', 'required') : ''}
                                           validate={this.validateComments}
                                           getLocalizedText={this.props.getLocalizedText}
                                           locale={this.props.locale} />
                        </StyledField>
                    </Row>

                </FeedbackDetails>
            </ContactUsFormStyled>
        );
    }
}

ContactUsForm.propTypes = {
    restaurantInfoOptional: PropTypes.bool,
    showMap: PropTypes.bool,
    date: PropTypes.string,
    time: PropTypes.string,
    diningType: PropTypes.string,
    comments: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    contactPreference: PropTypes.string,
    emailId: PropTypes.string,
    phone: PropTypes.string,
    preferredContactTime: PropTypes.string,
    handleFormUpdate: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onLocationSelection: PropTypes.func.isRequired,
    getLocalizedText: PropTypes.func.isRequired,
    errors: PropTypes.object,
    locations: PropTypes.array,
    locationSuggestions: PropTypes.array,
    locale: PropTypes.shape({
        country: PropTypes.string,
        language: PropTypes.string,
        localeCode: PropTypes.string
    })
};

ContactUsForm.defaultProps = {
    restaurantInfoOptional: false,
    showMap: false,
    date: '',
    time: '',
    diningType: '',
    comments: '',
    firstName: '',
    lastName: '',
    contactPreference: '',
    emailId: '',
    phone: '',
    preferredContactTime: '',
    handleFormUpdate: () => {},
    onSearch: () => {},
    onLocationSelection: () => {},
    getLocalizedText: (key, defaultValue) => defaultValue,
    errors: {},
    locations: [],
    locationSuggestions: [],
    locale: {
        country: 'US',
        language: 'en',
        localeCode: 'en_US'
    }
};

export default ContactUsForm;



// WEBPACK FOOTER //
// ./src/components/ContactUsForm/index.js